<script setup lang="ts">
import { UITag } from '@groover-dev/groover-ui'

/**
 * Displays a tag with the given label and color. Contrary to VPill (-> VChip in
 * new design system), this component is not an input and does not have a checkbox.
 * @deprecated Use UITag directly instead
 * @example
 * <!-- basic usage -->
 * <VTag label="Hello" />
 *
 * <!-- VTag with the green color -->
 * <VTag label="Hello" color="success" />
 */

type Props = {
  label?: string
  iconLeftName?: string
  color?:
    | 'default'
    | 'alt'
    | 'success'
    | 'warning'
    | 'error'
    | 'primary'
    | 'disabled'
}
const {
  label = '',
  color = 'default',
  iconLeftName = '',
} = defineProps<Props>()

const hasContent = computed(() => label || iconLeftName)
</script>

<template>
  <UITag
    v-if="hasContent"
    :key="`tag-${iconLeftName}${label}`"
    data-test-id="v-tag"
    :text="label"
    :color="color"
    :icon-left-name="iconLeftName"
    size="sm"
  />
</template>
